import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import { useState, useEffect } from "react";
import axios from "axios";

export default function NewsDetails() {
    const { t, i18n } = useTranslation();
    useScrollAnimation();

    const { id } = useParams();

    const [dataNews, setDataNews] = useState([]);
    const news = dataNews.find(item => item.id.toString() === id);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.alnujoud-jo.com/api/news");
                setDataNews(response.data.data);
            } catch (error) {
                console.error("Error When Fetch Data : ", error);
            }
        };
        fetchData();
    }, []);

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    if (!news) {
        return <div className="text-center text-red-500">{t("News not found")}</div>;
    }

    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("News & Events")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] font-bold">
                        <Link to={"/"}>{t("Home")}</Link> -
                        <span className="text-[#017E89] capitalize">{t("News & Events")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 w-full h-[450px]">
                        <img className="w-[100%] h-[100%] object-cover rounded-[8px]" src={news.image} alt={news.title_en} />
                    </div>
                    <div className="flex flex-col gap-[25px]">
                        <div className="flex items-center justify-between">
                            <div className="flex items-baseline gap-[7px]">
                                <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                                <div className="font-bold capitalize text-[25px] text-[#017e89]">
                                    {t(getLocalizedText({ A: news.title_ar, E: news.title_en }))}
                                </div>
                            </div>
                            <div className=" flex items-center gap-[5px]">
                                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/calender.svg").default} alt="" />
                                <div className="font-bold text-[#017E89]">
                                    {new Date(news.news_date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                                </div>
                            </div>
                        </div>
                        <p className="">
                            {t(getLocalizedText({ A: news.content_ar, E: news.content_en }))}
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}
